import React from 'react'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

import { Text, Icon, P } from '@mxenabled/mxui'

interface RequestSupportHeaderProps {
  content?: string
  hasIcon?: boolean
  institution?: string
  reverse?: boolean
  subtitle: string
  title: string
}

export const RequestSupportHeader: React.FC<RequestSupportHeaderProps> = ({
  content,
  hasIcon = true,
  institution = '',
  reverse = false,
  subtitle,
  title,
}) => (
  <React.Fragment>
    <Stack
      sx={{
        gap: 8,
        p: 24,
        pb: content ? 16 : 24,
        flexDirection: reverse ? 'column-reverse' : 'column',
      }}
    >
      <Box>
        <Stack gap={4} sx={{ alignItems: 'center', flexDirection: 'row' }}>
          {hasIcon && <Icon name="help" size={20} sx={{ color: 'text.primary' }} />}
          <Text color="text.primary" variant="h3">
            {title}
          </Text>
        </Stack>
        {institution && (
          <Text color="text.primary" variant="h3">
            {institution}
          </Text>
        )}
      </Box>
      <Text color="text.secondary" variant="body2">
        {subtitle}
      </Text>
    </Stack>
    {content && (
      <P color="text.secondary" sx={{ px: 24 }} variant="body2">
        {content}
      </P>
    )}
  </React.Fragment>
)
